import { earTrainingLogic } from './ear_training.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import {
  EarTrainingHost,
  EarTrainingProjector,
  EarTrainingStudent,
} from '../eval-blocks/MusicNativeViews';

export const earTrainingPlugin: ActivityPlugin<'ear_training'> = {
  ...earTrainingLogic,
  displayName: GAME_MODE_CATALOG.ear_training.displayName,
  icon: GAME_MODE_CATALOG.ear_training.icon,
  HostView: EarTrainingHost,
  StudentView: EarTrainingStudent,
  ProjectorView: EarTrainingProjector,
};

export { demoEarTrainingPayload } from './ear_training.logic';
